import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import Lock from './images/lock.inline.svg';

const cardSize = {
  xl: 'col-span-6',
  lg: 'col-span-4',
};

const SectionWithBigCards = ({ title, features, theme, withBackground }) => {
  const size = features.length === 2 ? 'xl' : 'lg';

  return (
    <section
      className={clsx('safe-paddings', {
        'bg-gray-1 py-40 xl:py-30 lg:py-20 md:py-14': withBackground,
      })}
    >
      <div
        className={clsx(
          'container flex flex-col items-center lg:max-w-[584px] md:w-full md:max-w-none',
          {
            'theme-red': theme === 'red',
            'theme-blue': theme === 'blue',
            'theme-green': theme === 'green',
          }
        )}
      >
        <h2
          className="text-5xl font-bold leading-denser"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <ul className="grid-gap grid w-full grid-cols-12 pt-16">
          {features.map(({ title, description }, index) => (
            <li
              className={clsx(
                'flex flex-col items-start rounded-2xl border border-gray-4 p-5 lg:col-span-full',
                cardSize[size]
              )}
              key={index}
            >
              <div className="flex items-start gap-x-2.5">
                <div
                  className={clsx('h-6 w-6 shrink-0 rounded-full', {
                    'bg-primary-2': theme === 'red',
                    'bg-secondary-2': theme === 'blue',
                    'bg-secondary-1': theme === 'green',
                  })}
                >
                  <Lock />
                </div>
                <h3 className="text-xl font-bold">{title}</h3>
              </div>
              <div
                className="color-list with-link-primary-2 mt-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

SectionWithBigCards.propTypes = {
  title: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  theme: PropTypes.string.isRequired,
  withBackground: PropTypes.bool.isRequired,
};

export default SectionWithBigCards;
